<template>
  <div class="multi-tabs">
    <aha-tabs-primary
      @update:activeIndex="onChangeTab"
      class="multi-tabs__header"
      :name="tabTitles[tabActiveIndex]"
      :activeIndex="tabActiveIndex"
    >
      <aha-tab-item
        v-for="(title, titleIndex) in tabTitles"
        :key="titleIndex"
        :title="$i18nPresenter.t(title)"
        :name="title"
      />
      <aha-icon
        v-if="closeable"
        name="close"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        class="multi-tabs__close-button"
        @click="onCloseButtonClicked()"
      />
    </aha-tabs-primary>
    <div v-for="(title, titleIndex) in tabTitles" :key="titleIndex" class="multi-tabs__content">
      <slot :name="`tab-${titleIndex}`" v-if="titleIndex === tabActiveIndex"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabTitles: {
      type: Array,
      default: () => [],
    },
    defaultTabIndex: {
      type: Number,
      default: 0,
    },
    closeable: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      tabActiveIndex: this.defaultTabIndex,
    }
  },
  methods: {
    onChangeTab(tabIndex) {
      this.tabActiveIndex = tabIndex
    },

    onCloseButtonClicked() {
      this.$emit('onCloseButtonClicked')
    },
  },
}
</script>

<style lang="scss" scoped>
.multi-tabs__close-button {
  @apply text-base-70 hover:text-primary-90;
  @apply cursor-pointer h-full;
}
</style>
